import React, { useState, useEffect } from 'react';
/*import "../../bootstrap/dist/css/bootstrap.min.css";*/
import axios from 'axios'
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PlayerFlag from '../../PlayerFlag'
import { Link } from "react-router-dom";
import { Bars } from "react-loader-spinner";
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from "react-promise-tracker";

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function Top100BlitzPlayers(props) {
    const [searchString, setSearchString] = useState("");
    const [players, setPlayers] = useState([]);
    const [searching, setSearching] = useState(false);
    const { promiseInProgress } = usePromiseTracker();
    const screenCenterStyle = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
    //{ textAlign: 'center' }; /*https ://github.com/davidhu2000/react-spinners/issues/53*/
    const centerDivStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '20vh'
    }; //https://www.c-sharpcorner.com/blogs/how-to-make-a-div-center-in-screen-in-react-js

    useEffect(async () => {
        trackPromise(
            axios.get('/api/TopFIDEPlayers/?top=100&ratingType=Blitz').then((response) => {
                const serachResults = response.data;
                setPlayers(serachResults);
            }).catch((error) => {
                console.log(JSON.stringify(error))
            })
        );


    }, []);
    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            }
        },
        {
            name: "fideTitle",
            label: "Title",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "fideBirthday",
            label: "Birthday",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: true,
                viewColumns: true
            }
        },
        {
            name: "fideCountry",
            label: "Flag",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortOrder: { name: 'id', direction: 'desc' },
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div>
                        <PlayerFlag key={value} code={(value === "" || value === null || value === undefined) ? "USA" : value} />
                    </div>
                )
            }
        },
        {
            name: "fideCountry",
            label: "Country",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div>
                        <span>{value ? value : "USA"}</span>
                    </div >

                )
            }
        },
        {
            name: "fideName",
            label: "Name",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let rowPlayer = players[originalIndex];
                    let idType = "FIDE";
                    let id = rowPlayer.fidePlayerId;
                    return (
                            <Link target="_blank" to={'/players/details?idtype='+idType+'&id='+id} className="button">
                                {value}
                            </Link>
                    )
                }
            }
        },
        {
            name: "fidePlayerId",
            label: "FIDE ID",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{ textAlign: "left" }}> {value !== -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel="noreferrer">{value}</a>) : (value)}</div>
                    );
                }
            }
        },
        {
            name: "fideBlitzRating",
            label: "Blitz",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: true,
                viewColumns: true
            }
        },
        {
            name: "fideRating",
            label: "Elo",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: "fideRapidRating",
            label: "Rapid",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                display: true,
                viewColumns: true
            }
        },
        {
            name: "",
            label: "",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let rowPlayer = players[originalIndex];
                    let idType = "FIDE";
                    let id = rowPlayer.fidePlayerId;
                    return (
                        <Button component={Link} target="_blank" to={'/players/details?idtype=' + idType + '&id=' + id} variant="contained" color="primary">
                                Games
                        </Button>
                    );
                }
            }
        },
    ];



    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: "vertical",
        expandableRows: false,
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        download: false,
        print: false,
        rowsPerPage: [5],
        rowsPerPageOptions: [5, 10, 15, 25, 50],
        fixedHeaderOptions: {
            xAxis: true,
            yAxis: true
        },
        resizableColumns: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: [],
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    return (
        <div>
            {(promiseInProgress === true) ?
                <Box sx={{ pt: 2, pb: 1 }}>
                    <div style={centerDivStyle}>
                        <Bars ariaLabel="Loading" color="#00BFFF" />
                    </div>
                    {/*<div style={spinnerStyle}>*/}
                    {/*    <Bars ariaLabel="Loading" color="#00BFFF" />*/}
                    {/*</div>    */}
                </Box>
                :
                <Box sx={{ pt: 0, pb: 1 }}>
                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                        {players.length > 0 ?
                            <Grid item xs={12}>
                                <div className="mt-10 mb-10">
                                    <CacheProvider value={muiCache}>
                                        <ThemeProvider theme={theme}>
                                            <MUIDataTable
                                                title={'Top 100 Blitz'}
                                                data={players}
                                                columns={columns}
                                                options={options}
                                                components={components}
                                            />
                                        </ThemeProvider>
                                    </CacheProvider>
                                </div>
                            </Grid>
                            :
                            <span>No games found for player in MetaDB</span>
                        }
                    </Grid>
                </Box>
            }
        </div>
        
        )
}

